import { storage } from "./firebase"
import { ref, uploadBytesResumable, getDownloadURL } from "@firebase/storage"

export const onImageUpload = (
  e,
  setSubmitBtnDisabled,
  setFormErrorMsg,
  setImageUrl
) => {
  if (e.target.files[0]) {
    const file = e.target.files[0]
    const storageRef = ref(storage, `/categories/${file.name}`)
    const uploadTask = uploadBytesResumable(storageRef, file)
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        //disbale submit button
        setSubmitBtnDisabled(true)
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.bytesTransferred) * 100
        )
        // enable submit button when image is uploaded
        if (progress === 100) {
          setSubmitBtnDisabled(false)
        }
      },
      (err) => {
        console.log("err", err)
        /**** */
        setFormErrorMsg({ image: "Could not upload image" })
        /**** */
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(
          (url) =>
            // uploaded image url
            setImageUrl(url)
          // return url to save in the DB
        )
      }
    )
  }
}
